import { useQuery } from "@tanstack/react-query";

import { bannersApi } from "@/api";
import { QueryKey } from "@/query/Query";

import { isBannerVisible } from "../MaintenanceBanner.utils";
import { useRefetchAtNextBannerTransition } from "./useRefetchAtNextBannerTransition";

const REFETCH_INTERVAL = 10 * 60 * 1000; //10 minutes

export function useMaintenanceBanner() {
  const { data: banner } = useQuery({
    queryKey: [QueryKey.MaintenanceBanner],
    queryFn: () => bannersApi.getActiveBanner(),
    refetchInterval: REFETCH_INTERVAL,
  });

  useRefetchAtNextBannerTransition(banner);

  return { banner: isBannerVisible(banner) ? banner : null };
}
